import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useCurrentSessionQuery, useGetCurrentUserQuery } from '../api';
import { login, logout, setIsLoading } from './reducers/session';

const useCurrentSession = () => {
  const { data: currentUser } = useGetCurrentUserQuery();

  const {
    isLoading,
    isSuccess,
    isError,
    data: currentSessionData
  } = useCurrentSessionQuery(undefined, {
    refetchOnFocus: false,
    pollingInterval: 0
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoading) {
      dispatch(setIsLoading(isLoading));
    }
  }, [isLoading, dispatch]);

  useEffect(() => {
    if (isError) {
      dispatch(setIsLoading(false));
    }
  }, [isError, dispatch]);

  useEffect(() => {
    if (!currentSessionData?.isLoggedIn) {
      dispatch(logout());
    }
  }, [currentSessionData, dispatch]);

  useEffect(() => {
    if (
      isSuccess &&
      currentSessionData &&
      currentSessionData.isLoggedIn &&
      currentUser
    ) {
      dispatch(
        login({
          id: currentUser.id,
          role: currentUser.role
        })
      );
      dispatch(setIsLoading(false));
    }
  }, [currentSessionData, currentUser, dispatch, isSuccess]);
};
export default useCurrentSession;
